import React, { ReactNode } from 'react';
import classnames from 'classnames';

interface Props {
    children: ReactNode;
    className?: string;
}

function Callout(props: Props) {
    const { children, className } = props;

    return <div className={classnames('bd-callout', 'bg-white', className)}>{children}</div>;
}

export default Callout;
